<template>
	<div style="display: flex; flex-direction: column">
		<div class="title">
			<div class="text">
				<span>归因信息</span>
			</div>
			<!-- 聊天时间24小时之内出现 -->
			<div
				class="refresh"
				@click="refresh"
				v-if="sourceType == 3 && this.$store.state.chat.refreshFlag"
			>
				点击刷新
			</div>
		</div>
		<div class="content">
			<div class="bg">
				<div class="tag">
					归因
					<clueMediumName
						:mediumName="attributionInformation"
						:mediumId="mediumId"
						v-if="attributionInformation"
						class="margintag"
					></clueMediumName>
				</div>
				<blockList :list="list" class="list" labelWidth="100px"></blockList>
			</div>
			<blockList :list="listTwo" class="list bg" labelWidth="100px"></blockList>
		</div>
	</div>
</template>

<script>
import clueMediumName from '@/components/crm/clue/clue-mediumName.vue';
import blockList from '@/components/client/clientModule/blockSpacList.vue';
import chatSer from '@/backend/services/chat/chatSer.js';
export default {
	props: {
		id: null,
		type: null,
		sourceType: null, //来源类型(1:Facebook广告;2:Messenger短链接;3:聊天插件;10:公共主页;)
	},
	data() {
		return {
			list: {},
			listTwo: {},
			attributionInformation: '',
			mediumId:''
		};
	},
	mounted() {},
	components: {
		blockList,
		clueMediumName,
	},
	watch: {
		id: {
			handler(val) {
				if (val) {
					this.getDetails();
				}
			},
			deep: true,
			immediate: true,
		},
		sourceType: {
			handler(val) {
				if (val) {
					this.getDetails();
				}
			},
			deep: true,
			immediate: true,
		},
	},
	computed: {},

	methods: {
		refresh() {
			this.getDetails();
		},
		async getDetails() {
			this.list = {};
			let res = await chatSer.attrDetails({
				id: this.id, //messengerUserId/询盘/客户id
				type: this.type, //类型(0,聊天;1,线索;3,客户;)
			});
			//来源类型(1:Facebook广告;2:Messenger短链接;3:聊天插件;10:公共主页;)
			let {
				attributionDetails,
				sourceContent,
				adTitle,
				photoUrl,
				videoLink,
				source,
				adSeries,
				keyword,
				msgPageUrl,
				ip,
				region,
				firstSubmitTime,
				firstSubmitPage,
				equipments,
			} = res.data;
			let equipmentstr = equipments ? equipments.join(',') : '';
			this.attributionInformation = res.data.attributionInformation;
			this.mediumId=res.data.mediumId;
			//来源类型(1:Facebook广告;2:Messenger短链接;3:聊天插件;10:公共主页;
			if (this.sourceType == 1) {
				this.list = {
					row1: [{ label: '归因详情', value: attributionDetails }],
					row2: [{ label: '广告标题', value: adTitle }],
					row3: [{ label: '图片链接', value: photoUrl }],
					row4: [{ label: '视频链接', value: videoLink }],
				};
				this.listTwo = {
					row1: [{ label: '对话来源', value: sourceContent }],
				};
			}
			if (this.sourceType == 10 ) {
				this.list = {
					row1: [{ label: '归因详情', value: attributionDetails }],
				};
				this.listTwo = {
					row1: [{ label: '对话来源', value: sourceContent }],
				};
			}
			if (this.sourceType == 2 || this.sourceType == 3) {
				this.list = {
					row1: [{ label: '归因详情', value: attributionDetails }],
					row2: [{ label: '来源/媒介', value: source }],
					row3: [{ label: '广告系列', value: adSeries }],
					row4: [{ label: '关键词', value: keyword }],
				};
				this.listTwo = {
					row1: [{ label: '对话来源', value: sourceContent }],
					row2: [{ label: '留言入口', value: msgPageUrl }],
					row3: [{ label: 'IP地址', value: ip }],
					row4: [{ label: '国家/地区', value: region }],
					row5: [{ label: '首次访问时间', value: firstSubmitTime }],
					row6: [{ label: '首次访问页面', value: firstSubmitPage }],
					row7: [{ label: '设备', value: equipmentstr }],
				};
			}
			if (!this.sourceType) {
				this.list = {
					row1: [{ label: '归因详情', value: attributionDetails }],
				};
				this.listTwo = {
					row1: [{ label: '对话来源', value: sourceContent }],
				};
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.title {
	font-weight: 500;
	color: #333333;
	font-size: 16px;
	padding: 20px;
	display: flex;
	justify-content: space-between;

	.text {
		span {
			margin-right: 10px;
		}
		display: flex;
		margin-right: 20px;
	}
}
.refresh {
	color: #3da1ff;
	cursor: pointer;
	font-size: 14px;
}
.content {
	/* height: calc(100vh - 580px); */
	// overflow-y: auto;
	margin: 0px 20px;
	// padding: 20px 0px;
	.bg {
		background: #f8f9fc;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 10px;
	}
	// // 改变滚动条样式
	// &::-webkit-scrollbar {
	// 	width: 5px;
	// }

	// &::-webkit-scrollbar-thumb {
	// 	background-color: #e8e8e8;
	// 	border-radius: 6px;
	// }

	// &::-webkit-scrollbar-track {
	// 	background-color: #fff;
	// 	border-radius: 2px;
	// }
}
.tag {
	margin: 0px 0px 10px 30px;
	display: flex;
	font-weight: 500;
	.margintag {
		margin-left: 15px;
	}
}
</style>
